__turbopack_context__.v({
  "cardsSwiper": "style-module-scss-module__Gr86Nq__cardsSwiper",
  "pagination": "style-module-scss-module__Gr86Nq__pagination",
  "paginationHidden": "style-module-scss-module__Gr86Nq__paginationHidden",
  "section": "style-module-scss-module__Gr86Nq__section",
  "slide": "style-module-scss-module__Gr86Nq__slide",
  "sliderWrap": "style-module-scss-module__Gr86Nq__sliderWrap",
  "title": "style-module-scss-module__Gr86Nq__title",
});
